import { UserWithCustomerOrCompany } from './user-with-customer-or-company.type';

export class CardData {
  user: UserWithCustomerOrCompany;
  isClient: boolean;
  clientUrl: (string | number)[] | string | null | undefined;
  subtitle: string;
  subtitleIcon: string;
}
